export const normalizeToPlainText = (value: string): string =>
  value
    ? value
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    : '';
